import { useState } from 'react';

export type FileType =
  | 'PDF'
  | 'REPORT_VIEW'
  | 'HTML'
  | 'CSV'
  | 'ZIP'
  | 'XML'
  | 'TXT';

type FileLoading = {
  PDF?: boolean;
  REPORT_VIEW?: boolean;
  HTML?: boolean;
  CSV?: boolean;
  XML?: boolean;
  TXT?: boolean;
};

export const FILE_FORMAT = {
  PDF: 'PDF',
  REPORT_VIEW: 'PDF',
  HTML: 'HMTL',
  CSV: 'CSV',
  ZIP: 'ZIP',
  XML: 'XML',
  TXT: 'TXT',
};

function useFileLoading() {
  const [fileLoading, setLoading] = useState<FileLoading>({});

  function setFileLoading(fileType: FileType) {
    setLoading({ [fileType]: true });
  }

  function setFileUnloading(fileType: FileType) {
    setLoading({ [fileType]: false });
  }

  return {
    fileLoading,
    setFileLoading,
    setFileUnloading,
    FILE_FORMAT,
  };
}

export default useFileLoading;
